import React, { Component } from 'react'
import BkFlowPostEnhancements from '../../components/enhancements/BkFlowPostEnhancements'
import BkFlowConfirmation from '../../components/confirmation/BkFlowConfirmation'
import { connect } from 'react-redux'
import yn from 'yn'

import triggerCustomGaEvent from '../../utilities/analytics/triggerCustomGaEvent'

class BkFlowConfirmationContain extends Component {

	constructor(props) {
		super(props)
		this.state = {
		}
	}

	componentDidMount() {
		window.history.pushState( {} , '', '/book/confirmation?' + this.props.currentQuery.query )

		// Dispatch activeRoom GA events
		triggerCustomGaEvent('analytics-pageView', window.location.href)
	}

	render() {
		return (
			<div className={`bk-flow-confirmation ${process.env.REACT_APP_COMPONENT_CONFIRMATION_LAYOUT}`}>
				<div className="u-container">
					{ yn(process.env.REACT_APP_COMPONENT_POST_ENHANCEMENTS) &&
						<BkFlowPostEnhancements />
					}

					<BkFlowConfirmation />
				</div>
			</div>
		)
	}
}

function mapStateToProps(state) {
	return {
		currentQuery: state.availabilityData.currentQuery,
		urlData: state.availabilityData.urlData,
	}
}

export default connect(mapStateToProps, null)(BkFlowConfirmationContain)


// WEBPACK FOOTER //
// ./src/containers/confirmation/BkFlowConfirmationContain.js